<template>
  <div>
    <v-container>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field v-model="email" :rules="emailRules" :label="$t('login.Email')" required/>
        <v-text-field
          v-model="password"
          :append-icon="show1 ? 'visibility' : 'visibility_off'"
          :rules="passwordRules"
          :type="show1 ? 'text' : 'password'"
          name="input-10-1"
          :label="$t('login.Password')"
          counter
          required
          @click:append="show1 = !show1"
        />
        <v-btn
          class="mt-2"
          depressed
          :disabled="!valid"
          :loading="loading"
          color="success"
          @click="login"
        >
          <v-icon left>account_box</v-icon>
          {{$t('common.LogIn')}}
        </v-btn>
        <v-layout align-center class="caption mt-5">
          {{$t('login.DoYouNotHaveAnAccount?')}}
          <v-btn :to="{ name: 'Signup' }" flat>{{$t('login.SignUp')}}</v-btn>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    show1: false,
    loading: false,
    valid: true,
    password: "",
    email: ""
  }),
  computed: {
    emailRules() {
      return [
        v => !!v || this.$t("login.EmailRequired"),
        v => /.+@.+/.test(v) || this.$t("login.WrongEmailFormat")
      ];
    },
    passwordRules() {
      return [v => !!v || this.$t("common.RequiredField")];
    }
  },
  methods: {
    ...mapActions(["login"])
  }
};
</script>

<style>
</style>
